module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"error":"Company couldn\u0027t be added. Please fix the error."}}')
  delete Component.options._Ctor
}
